<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Account type</div>
            <fieldset class="border p-3">
              <div>
                <form @submit.prevent="newAccount()">
                  <div class="form-group">
                    <label>Account name</label>
                    <input
                      type="text"
                      class="form-control account_name"
                      placeholder="accounttype name"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat creatingAccounttype btn-rounded"
                  >
                    <i class="fa fa-plus"></i> create Account type
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-flat creatingAccounttypeLoader btn-rounded"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["newAccount"]),
  },
};
</script>
<style scoped>
.creatingAccounttypeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/accounttypes/accounttype.vue